// İSG uzmanı portalı — Ziyaretçiler (Visits) kabuğu (S33 Slice 5, owner kararı — kabuk KENDİ
// Breadcrumb+PageHeader'ını taşır; `docs/plans/S33-carbon-reskin.md` Slice 5, `docs/BACKLOG.md`
// "known exception"ini kapatır). PageHeader'ın sağındaki birincil aksiyon o an AKTİF sekmenin
// kendisidir (`ShellHeaderAction` portal köprüsü — bkz. o dosyanın başlığı). Alt ekranlar (sahada/
// geçmiş/güvenlik brifingi) `Outlet` ile render edilir; `OnSiteVisitorsPage`/`VisitHistoryPage`
// artık kendi yerel `<h2>`'sini TAŞIMAZ (kabuğun `<h1>`'i TEK gerçek başlık) —
// `SafetyBriefingPage` bu turda DOKUNULMADI (S33 planı Slice 6'nın işi, plan §6). "Sahada" sekmesi
// kök yoldur (`/visitors`) → `end` ile yalnız tam eşleşmede aktif olur.

import { Breadcrumb, PageHeader } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { RouteTabs } from '../../components/layout/RouteTabs';
import {
  ShellHeaderActionProvider,
  useShellHeaderActionSlot,
} from '../../components/layout/ShellHeaderAction';

export function VisitorsShell() {
  const { t } = useTranslation();
  const { slotRef, slot } = useShellHeaderActionSlot();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('visitors.title') }]} />
      <PageHeader title={t('visitors.title')} helperText={t('visitors.subtitle')} actions={slot} />
      {/* Sekme listesi + gövde ARASINDA boşluk YOK (S33 Slice 6 owner kararı, bkz.
          `SettingsShell.tsx`'in aynı notu). */}
      <div className="flex flex-col">
        <RouteTabs
          ariaLabel={t('visitors.title')}
          items={[
            { to: '/visitors', end: true, label: t('visitors.tab.onSite') },
            { to: '/visitors/history', label: t('visitors.tab.history') },
            { to: '/visitors/safety-briefing', label: t('visitors.tab.briefing') },
          ]}
        />
        <ShellHeaderActionProvider value={slotRef}>
          <Outlet />
        </ShellHeaderActionProvider>
      </div>
    </div>
  );
}
